import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigProvider, theme } from "antd";
import { store } from "./store";
import AppLayout          from "./components/common/AppLayout";
import ProtectedRoute     from "./components/common/ProtectedRoute";
import LoginPage          from "./pages/LoginPage";
import UploadPage         from "./pages/UploadPage";
import FilingsPage        from "./pages/FilingsPage";
import BenchmarkPage      from "./pages/BenchmarkPage";
import ResultsPage        from "./pages/ResultsPage";
import HumanReviewPage    from "./pages/HumanReviewPage";
import ReviewQueuePage    from "./pages/ReviewQueuePage";
import UsersPage          from "./pages/UsersPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";

const antdTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary:  "#1A3C5E",
    colorLink:     "#2E86AB",
    borderRadius:   6,
    fontFamily:    "'Inter', sans-serif",
  },
};

export default function App() {
  return (
    <Provider store={store}>
      <ConfigProvider theme={antdTheme}>
        <BrowserRouter>
          <Routes>
            {/* ── Public ──────────────────────────────────────────────── */}
            <Route path="/login" element={<LoginPage />} />

            {/* ── Protected (all roles) ──────────────────────────────── */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/upload" replace />} />

              <Route path="upload"    element={<UploadPage />} />
              <Route path="filings"   element={<FilingsPage />} />
              <Route path="benchmark/:filingId" element={<BenchmarkPage />} />
              <Route path="results/:runId"      element={<ResultsPage />} />
              <Route path="review-queue"        element={<ReviewQueuePage />} />
              <Route path="review/:resultId"    element={<HumanReviewPage />} />
              <Route path="change-password"     element={<ChangePasswordPage />} />

              {/* ── Admin only ─────────────────────────────────────── */}
              <Route
                path="users"
                element={
                  <ProtectedRoute role="admin">
                    <UsersPage />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/upload" replace />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
}